import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import axios from "axios";
import { differenceInDays, parseISO } from "date-fns";

const BookHotelsModal = ({ isOpen, onClose, dest_id, startDate, endDate, rooms, adults, children }) => {
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);  // 分頁

  const nights = differenceInDays(parseISO(endDate), parseISO(startDate));

  useEffect(() => {
    if (isOpen && dest_id) {
      handleSearchHotels();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, dest_id, startDate, endDate, rooms, adults, children, page]);

const handleSearchHotels = async () => {
  if (!dest_id) {
    alert("Missing destination ID");
    return;
  }
  setLoading(true);
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/lodging/search`, {
      params: {
        dest_id,
        checkin: startDate,
        checkout: endDate,
        rooms,
        adults,
        children,
        page_number: page,  // Booking v2 頁碼從 0 開始
      },
    });

    // 🔑 改這裡
    const results = res.data?.results || [];
    setHotels(results);
  } catch (err) {
    console.error(err);
    alert("Failed to fetch hotels");
  } finally {
    setLoading(false);
  }
};


  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-xl font-semibold mb-4">Available Hotels</h2>

      {loading && <div className="mt-4">Loading...</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {hotels.map((hotel) => (
          <div
            key={hotel.id}
            className="border rounded-lg shadow hover:shadow-md transition p-3 flex flex-col"
          >
            {/* Hotel Image */}
            {hotel.photoMainUrl && (
              <img
                src={hotel.photoMainUrl}
                alt={hotel.name}
                className="w-full h-48 object-cover rounded mb-3"
              />
            )}

            {/* Hotel Info */}
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-primary">{hotel.name}</h3>
              <p className="text-sm text-gray-600">{hotel.address}</p>

              {/* Reviews */}
              {hotel.reviewScore && (
                <p className="text-sm mt-1 text-gray-700">
                  ⭐ {hotel.reviewScore} / 10 ({hotel.reviewScoreWord} reviews)
                </p>
              )}

				{/* 房型資訊 */}
				{hotel.proposedAccommodation && hotel.proposedAccommodation.length > 0 && (
				  <p className="text-sm text-gray-800 mt-2">
					{hotel.proposedAccommodation.join(" • ")}
				  </p>
				)}
				
				{hotel.priceDetails?.info && (
					<p className="text-sm mt-1 text-gray-700">
						{hotel.priceDetails?.info}
					</p>	
				)}

				{/* 價格區塊 */}
				<div className="mt-3">
				  {/* 原價 */}
				  {hotel.priceDetails?.strikethrough && (
					<p className="text-sm text-gray-500 line-through">
					  {hotel.priceDetails.strikethrough}
					</p>
				  )}

				  {/* 現價 */}
				  {hotel.priceDetails?.gross ? (
					<p className="text-lg font-bold text-green-700">
					  {hotel.priceDetails.gross}
					</p>
				  ) : (
					<p className="text-gray-500">N/A</p>
				  )}
				</div>

            </div>

            {/* Link */}
            <div className="mt-4">
				<a
				  href={`https://www.booking.com/hotel/${hotel.countryCode || "xx"}/${hotel.id}.html`}
				  target="_blank"
				  rel="noopener noreferrer"
				  className="block text-center bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700"
				>
				  See availability
				</a>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-6">
        <button
          disabled={page === 0}
          onClick={() => setPage((p) => Math.max(0, p - 1))}
          className="bg-gray-500 text-white px-4 py-2 rounded disabled:opacity-50"
        >
          Previous
        </button>
        <span>Page {page + 1}</span>
        <button
          onClick={() => setPage((p) => p + 1)}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Next
        </button>
      </div>

      <div className="text-right mt-6">
        <button
          onClick={onClose}
          className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default BookHotelsModal;
